<template>
  <div class="text-left mb-3">
    <div class="d-flex align-items-center mb-2">
      <font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" />
      <v-label class="label-input">{{ label }}</v-label>
    </div>

    <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field :value="formattedValue" readonly outlined dense :name="name" :data-vv-as="(label || '').replace('*', '').trim()"
          v-validate="rules" v-bind="attrs" v-on="on" />
      </template>

      <v-date-picker v-model="innerValue" type="date" locale="es" @input="handleDateSelect"></v-date-picker>
    </v-menu>

    <span class="red--text">{{ validationErrors.first(name) }}</span>
  </div>
</template>

<script>
export default {
  name: "BaseDatePicker",
  // Usa el validador del formulario que lo contiene, asi sus reglas (ej: required) bloquean el guardado
  inject: ["$validator"],
  props: {
    value: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: String,
      default: "",
    },
    validationErrors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      menu: false,
      innerValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  computed: {
    formattedValue() {
      if (!this.value) return "";
      const [year, month, day] = this.value.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  methods: {
    handleDateSelect(val) {
      this.menu = false;
      this.$emit("input", val);
    }

  },
};
</script>

<style scoped>
.icon-chevron {
  font-size: 12px;
}

.label-input {
  font-weight: 500;
}
</style>
